export function deriveHours(hours) {
    const required = Number(hours?.total_required ?? hours?.required ?? 0) || 0;
    const approved = Number(hours?.total_approved ?? hours?.approved ?? 0) || 0;
    const remaining = hours?.remaining != null
        ? Math.max(0, Number(hours.remaining) || 0)
        : Math.max(0, required - approved);
    const progress = required > 0 ? Math.round((approved / required) * 100) : 0;

    return { required, approved, remaining, progress };
}

export function nextJourneyHref(dashboard) {
    const route = dashboard?.nextAction?.route;
    if (typeof route === 'string' && route.startsWith('/')) return route;
    if (dashboard?.currentStage?.route) return dashboard.currentStage.route;
    return '/journey';
}

export function displayNameFromDashboard(dashboard, user) {
    const fromProfile = dashboard?.profile?.fullName || dashboard?.profile?.firstName;
    if (fromProfile && fromProfile !== 'there') return fromProfile.split(' ')[0];
    return user?.first_name || 'there';
}

export function encouragementCopy(hours) {
    const progress = Number(hours?.progress) || 0;
    if (progress <= 0) {
        return 'You are just getting started. Keep going — you are building real professional AI experience.';
    }
    return "You're making great progress. Keep going — you're building real professional AI experience.";
}
